import * as React from 'react';
import { Global } from '@emotion/react';
import CssBaseline from '@mui/material/CssBaseline';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import './Drawer.css'
import MainMenu from '../mainMenu/MainMenu';

const drawerBleeding = 0;

function Drawer() {
    const [open, setOpen] = React.useState(false);
    const [page, setPage] = React.useState(0);
    const [time, setTime] = React.useState(null);

    const setWakeUpTime = (time) => {
        setTime(time);
    }

    const toggleDrawer = (newOpen) => () => {
        setOpen(newOpen);
        setPage(0);
    };

    //TODO: Find why the toggleDrawer cannot be used in props
    const close = (isOpen) => {
        setOpen(isOpen);
    }

    const navigate = (page) => {
        setPage(page);
    };

    return (
        <div id={'wrapper'}>
            <CssBaseline />
            <Global
                styles={{
                    '.MuiDrawer-root > .MuiPaper-root': {
                        height: `calc(80% - ${drawerBleeding}px)`,
                        overflow: 'visible',
                    },
                }}
            />
            <btn onClick={toggleDrawer( true)}>Assistant de charge</btn>
            <SwipeableDrawer
                anchor="bottom"
                open={open}
                onClose={toggleDrawer(false)}
                onOpen={toggleDrawer(true)}
                swipeAreaWidth={drawerBleeding}
                disableSwipeToOpen={false}
                BackdropProps={{
                    invisible: true // Empêche l'assombrissement du fond
                }}
                ModalProps={{
                    keepMounted: false // Permet au tiroir de rester monté dans le DOM même lorsqu'il est fermé
                }}
            >

                {(() => {
                    switch(page) {
                        case 0:
                            return <MainMenu close={close} navigate={navigate} />
                        default:
                            return null
                    }
                })()}

            </SwipeableDrawer>
        </div>
    );
};

export default Drawer;